import { createSelector } from "reselect";
import { getZendeskUnreadMessagesCountSelector } from "../../../modules/Zendesk/zendeskSelectors";

export const getShowMobileMenuProfileBadgeSelector = createSelector(
    getZendeskUnreadMessagesCountSelector, unreadMessagesCount => unreadMessagesCount > 0
);
